import { render } from "./how_to_use.vue?vue&type=template&id=3c0466d0"
import script from "./how_to_use.vue?vue&type=script&lang=js"
export * from "./how_to_use.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__